import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/Rx';

import { GUID } from "app/brightserve/brightserve.module";
import { User } from "app/shared/shared.module";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
@Injectable()
export class AdminUserService {

    constructor(private http: HttpClient) { }

    GetUserDetailsById(Id: GUID): Observable<User> {
        return this.http.get("/user/" + Id + "/details").map((res: any) => new User(res.User) || {});
    };
    GetCurrentUserDetails(): Observable<User> {
        return this.http.get("/user/details").map((res: any) => new User(res.User) || {});
    };

    ChangeDetails(ChangeDetails): Observable<User> {
        var data = {
            User: {
                Id: ChangeDetails.Id,
                Username: ChangeDetails.Username,
                Name: ChangeDetails.Name,
                UserType: ChangeDetails.UserType,
                IsClient: ChangeDetails.IsClient,
                IsDoctor: ChangeDetails.IsDoctor,
            }
        };
        return this.http.post("/user/changedetails", data).map((res: any) => new User(res.User) || {});
    }

    ChangePassword(PasswordChange): Observable<User> {
        return this.http.post("/user/changepassword", PasswordChange).map((res: any) => new User(res.User) || {});
    }
}



// WEBPACK FOOTER //
// ./src/app/adminuser/adminuser.service.ts